
var titleSignIn = document.getElementById("title-sign-in");
var titleRegister = document.getElementById("title-register");
var formSignIn = document.getElementById("form-login");
var formRegister = document.getElementById("form-register");
function showSignIn() {
  const checkErrMessageSign = formSignIn.querySelector(".errors");
  if(titleSignIn.classList.contains('active') == false) {
    titleSignIn.classList.add("active");
    titleRegister.classList.remove("active");
    formSignIn.style.display = "block";
    formRegister.style.display = "none";
  }
  if (checkErrMessageSign) {
    checkErrMessageSign.remove();
  }
}
function showRegister() {
  const checkErrMessageRegis = formRegister.querySelector(".message-errors-regis");
  if(titleRegister.classList.contains('active') == false) {
    titleRegister.classList.add("active");
    titleSignIn.classList.remove("active");
    formSignIn.style.display = "none";
    formRegister.style.display = "block";
  }
  if (checkErrMessageRegis) {
    checkErrMessageRegis.remove();
  }
}
